//Feature this is temporary:
//the user's preferences must be inserted in a state, 
//and with each change in this state, call the user's update in the API
import { IUserPreferenceDataRequest } from "../context/types";
import { GetUserPreferenceDataRequestApiHelper } from "../utils/UserPreferenceDataRequestHelper";
//a redux must be created to work with it
export async function UpdatePreferences(token: string | null, requestData: IUserPreferenceDataRequest) {
    const axios = require('axios');

    const userDataRequest = GetUserPreferenceDataRequestApiHelper(requestData);
    const Value = JSON.stringify(userDataRequest);
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_HOST + 'api/user',
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data:
        {
            Value
        },
    };

    const request = await axios.request(options);
    if(request.status === 200 && userDataRequest != null){
        request.data.Praca = userDataRequest.Praca;
    }
    return request;
}
export async function User(token: string | null) {
    const axios = require('axios');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_HOST + 'api/user',
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
            Accept: "application/json",
        }
    }

    const request = await axios.request(options);
    return request;
} 